"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonBorderRadius = exports.borderTheme = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const borderTheme = (0, _sdsThemeInternal.themed)({
  large: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius35
  },
  medium: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius30
  },
  small: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius30
  },
  xsmall: {
    "lodestar-light": _designTokens.border.radius10,
    "ursa-light": _designTokens.border.radius20
  }
});
exports.borderTheme = borderTheme;
const getButtonBorderRadius = _ref => {
  let {
    themeMode,
    size
  } = _ref;
  return borderTheme[size](themeMode);
};
exports.getButtonBorderRadius = getButtonBorderRadius;
//# sourceMappingURL=getButtonBorderRadius.js.map